import React from 'react';
import '../styles/Studies.css';

const studies = [
  {
    stat: '$150bn',
    description: 'lost annually by businesses due to sleep-related fatigue, including absenteeism, workplace accidents, and reduced productivity.',
    source: 'National Academies of Sciences',
    link: 'https://www.ncbi.nlm.nih.gov/books/NBK19958/',
  },
  {
    stat: '+12%',
    description: 'average productivity gain found in workers whose wellbeing was actively supported, evidence that investing in employee happiness delivers measurable returns.',
    source: 'University of Warwick',
    link: 'https://wrap.warwick.ac.uk/id/eprint/63228/7/WRAP_Oswald_681096.pdf',
  },
  {
    stat: '20%',
    description: 'of accidents on major roads are linked to fatigue, which has also been implicated in disasters including the Chernobyl explosion and Exxon Valdez oil spill.',
    source: 'Health & Safety Executive',
    link: 'https://www.hse.gov.uk/humanfactors/topics/fatigue.htm',
  },
];

const LinkIcon = () => (
  <svg className="link-icon" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z" clipRule="evenodd"/>
  </svg>
);

function StudyCard({ stat, description, source, link }) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="study-card"
    >
      <span className="study-stat">{stat}</span>
      <p>{description}</p>
      <span className="study-source">
        <LinkIcon />
        {source}
      </span>
    </a>
  );
}

function Studies() {
  return (
    <section className="studies" id="studies">
      <div className="section-container">
        <div className="section-header">
          <h2>Backed by research</h2>
          <p className="section-subtitle">
            Regular wellness monitoring is not just good for employees. It is good for business.
          </p>
        </div>

        <div className="studies-grid">
          {studies.map((study) => (
            <StudyCard key={study.stat} {...study} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Studies;
